import { Grid } from '@mui/material';
import { WithGorillaInnerTheme } from './with-inner-theme';
export var GorillaGrid = WithGorillaInnerTheme(Grid);
